export const IFP_MINIMUM_CHARGE_AMOUNT = 0
export const IFP_MAXIMUM_CHARGE_AMOUNT = 200
